<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold  mt-3">{{$t('medium_grant_ev.diligence__big_title')}}</h4>
            <p class="white-space-pre">{{$t('medium_grant_ev.diligence__big_title_sub')}}</p>
            <application-info></application-info>
          </div>
        </div>
      </div>

      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox,
      ApplicationInfo
    },
    data() {
      return {
        EvaluationForm,
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>